import TabsTemplate from "../../../common/components/TabsTemplate";
import OrderWorkflow from "./OrderWorkflow";
import {useMemo} from "react";
import ProductWorkflow from "./ProductWorkflow";
import CustomerWorkflow from "./CustomerWorkflow";
import InventoryWorkflow from "./InventoryWorkflow";
import LoyaltyWorkflow from "./LoyaltyWorkflow";
import {REACT_FLOW_LINK} from "../../../../utils/constants";
import orderWorkflowsImg from "/public/reactFlow/workflows/Order-Workflow.png";
import {RF_NAMESPACE} from "../../../../utils/i18nNameSpaces";
export const ORDER_WORKFLOWS = "Order-Workflows";
export const Product_Workflows = "Product-Workflows";
export const Customer_Workflows = "Customer-Workflows";
export const Inventory_Workflows = "Inventory-Workflows";
export const Customers_loyalty_Workflows = "Customers-loyalty-Workflows";

const Workflow = () => {
  const list = [
    "Order-Workflows",
    "Product-Workflows",
    "Customer-Workflows",
    "Inventory-Workflows",
    "Customers-loyalty-Workflows"
  ]

  const componentList = useMemo(() => (
    [
      <OrderWorkflow/>,
      <ProductWorkflow/>,
      <CustomerWorkflow/>,
      <InventoryWorkflow/>,
      <LoyaltyWorkflow/>

    ]
  ), [])

  return (
    <>
      <TabsTemplate namespace={RF_NAMESPACE} componentsList={componentList} stateList={list} link={REACT_FLOW_LINK} mobileImg={orderWorkflowsImg}/>
    </>
  );
};

export default Workflow;